import { v4 as uuid } from 'uuid';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

interface UseFirePricingPlanCtaEventProps {
	edition?: string;
	productKey: string;
	containerId: string;
}
export function useFirePricingPlanCtaEvent(props: UseFirePricingPlanCtaEventProps) {
	const { edition, productKey, containerId } = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const createPayload = (): AnalyticsEventPayload => ({
		eventType: 'ui',
		action: 'clicked',
		actionSubject: 'linkButton',
		containerId,
		actionSubjectId: 'pricingPlanCta',
		attributes: {
			migrationExperimentCta: true,
			pricingEventId: uuid(),
			productKey,
			edition,
		},
	});

	return () => createAnalyticsEvent(createPayload()).fire();
}
